import "./CollectionItem.scss";
import { ICollection } from "@/common/services/types";
import BookMarkIcon from "@/common/images/BookMarkIcon.svg";
import { useSfw } from "@/common/hooks/useSfw";

interface ICollectionItem {
  addToCollections: (folderId: string) => void;
  collection: ICollection;
}

export const CollectionItem = (props: ICollectionItem) => {
  const { sanitizeImage, isLoading } = useSfw();

  const {
    collection: {
      folderId,
      folderName,
      thumbs
    },
    addToCollections
  } = props;

  const preview = thumbs ? sanitizeImage(thumbs) : BookMarkIcon;

  if (isLoading) {
    return null;
  }

  return (
    <div className="CollectionItem" onClick={() => addToCollections(folderId)}>
      <div className="CollectionItem-Img">
        <img src={preview} className={!thumbs ? "bookmarkIcon" : ""} width={48} height={48} alt={`Poster for ${folderName} collection`} />
      </div>
      <span className="CollectionItem-Title">{folderName}</span>
    </div>
  );
};
